import ShRecordPlayer from '@/components/Helpers/ShRecordPlayer';
import ShButton from '@/components/Helpers/ShButton';

export default {
  name: 'TheRecordPlayer',

  components: {
    ShButton,
    ShRecordPlayer,
  },

  data() {
    return {
      isHidden: false,
    };
  },
  beforeDestroy() {
    this.$refs.player.playerStopPlay();
  },
  methods: {
    togglePlayerVisibility() {
      this.isHidden = !this.isHidden;
    },
    handleClosePlayer() {
      this.$EventBus.$emit('PlatformConnections/TURN_PLAYER_VISIBILITY_OFF');
      // this.$EventBus.$off('RecordListItem/GET_RECORD_DETAILS');
    },
  },
};
